@import 'styles/mixins';
@import 'styles/blaze/mixins';
@import 'styles/variables';

.modifiedHeader {
  padding-bottom: 16px;
}

.parentButton {
  gap: 6px;
  max-width: 100%;
  padding: 6px 8px;
  width: fit-content;

  .text {
    @include line-clamp;
  }

  .icon {
    align-items: center;
    display: flex;
    font-size: 16px;

    &.withFill {
      svg {
        fill: var(--dark-40);
      }
    }

    svg {
      height: 16px;
      width: 16px;
    }
  }
}

.header {
  display: flex;
  flex-direction: column;
  width: 100%;

  .titleRow {
    align-items: center;
    display: flex;

    .icon {
      align-items: center;
      display: flex;
      font-size: 24px;
      height: 24px;
      margin-right: 10px;
      width: 24px;

      svg {
        height: 24px;
        width: 24px;
      }
    }
  }
}

.width80 {
  width: 80% !important;

  @include for-phone-only {
    width: 180px !important;
  }
}

.title {
  @include line-clamp;
  @include lg-sohne;

  color: var(--dark-80);
  max-width: 480px;

  &.twoLines {
    overflow: auto;
    white-space: break-spaces;
  }
}

.shareSheetContents {
  min-height: 350px;
}

.loadingState {
  margin-top: 12px;

  :global {
    .ant-skeleton-title {
      margin: 0 0 16px;
    }
  }
}

.loadingRow {
  align-items: center;
  display: flex;
  justify-content: space-between;
  margin-bottom: 16px;

  &.flush {
    margin-bottom: 0;
  }

  &.smallAvatar {
    :global {
      .ant-skeleton-header {
        padding-right: 8px;
        vertical-align: middle;
      }

      .ant-skeleton-title {
        margin: 0 !important;
      }

      .ant-skeleton-avatar {
        height: 16px !important;
        width: 16px !important;
      }
    }
  }

  :global {
    .ant-skeleton-header {
      display: block;
      height: 24px;
    }

    .ant-skeleton-title {
      border-radius: 4px;
      margin: 4px 0 0 !important;
    }

    .ant-skeleton-avatar {
      border-radius: 50%;
      height: 24px !important;
      width: 24px !important;
    }
  }
}

.recipientSelector {
  @include input-border;
  align-items: center;
  background-color: var(--light-100);
  border-radius: 6px;
  color: var(--dark-40);
  display: flex;
  justify-content: space-between;
  padding-left: 10px;

  &.withPeople {
    padding: 5px 5px 5px 10px;
  }

  &.alignTop {
    align-items: flex-start;

    input {
      min-height: 45px;
    }
  }

  input {
    min-height: 24px;
  }

  .toLabel {
    @include md-sohne;

    color: var(--dark-40);
    margin-right: 10px;
    padding-top: 8px;
    width: auto;
  }

  .recipientSelectorContainer {
    width: 100%;
  }
}

.inviteUsers {
  .adminSubheaderContainer {
    @include sm-sohne;

    align-items: center;
    color: var(--dark-40);
    display: flex;
    justify-content: space-between;
    margin-top: 12px;
  }

  .subheaderContainer {
    @include sm-sohne;

    color: var(--dark-40);
    margin-top: 12px;

    .inheritedContainer {
      align-items: center;
      display: flex;
      justify-content: space-between;
      margin-top: 4px;

      @include for-phone-only {
        flex-direction: column;
      }
    }
  }
}

.inheritedAccessRow {
  @include sm-sohne;

  align-items: center;
  color: var(--dark-40);
  display: flex;
  gap: 6px;
  padding-left: 2px;

  .truncatedAccessorName {
    @include line-clamp;

    max-width: 180px;

    @include for-phone-only {
      max-width: 130px;
    }
  }

  .accessContainer {
    align-items: center;
    display: flex;
    gap: 4px;
  }

  svg {
    height: 16px;
    width: 16px;
    min-height: 16px;
    min-width: 16px;
  }
}

.groupItems {
  align-items: center;
  display: flex;

  &:hover {
    background-color: var(--dark-6);
  }

  svg {
    fill: var(--dark-40);
  }

  .counter {
    @include sm-sohne;

    align-items: center;
    background-color: var(--dark-6);
    border-radius: 12px;
    color: var(--dark-60);
    display: flex;
    height: 20px;
    justify-content: center;
    margin: 0 4px;
    min-height: 20px;
    min-width: 20px;
    padding: 0 4px;
  }
}

.openFooterButton {
  @include sm-sohne;

  align-items: center;
  background-color: var(--light-100);
  border: 1px solid var(--dark-10);
  border-radius: 22px;
  display: flex;
  gap: 2px;
  left: 50%;
  padding: 6px;
  position: absolute;
  transform: translate(-50%);
  top: -15px;
  width: auto;

  .openFooterText {
    margin-left: 4px;
  }

  svg {
    height: 16px;
    width: 16px;
  }

  .toggleIcon {
    height: 16px;
    width: 16px;

    svg {
      fill: var(--action-60);
    }
  }

  &:hover {
    cursor: pointer;
  }
}

.closeFooterButton {
  align-items: center;
  background-color: var(--light-100);
  border-radius: 19px;
  border: 1px solid var(--dark-10);
  bottom: -10px;
  display: flex;
  height: 20px;
  left: 50%;
  padding: 2px;
  position: absolute;
  transform: translate(-50%);
  width: 20px;

  &:hover {
    cursor: pointer;
  }
}

.popoverContainer {
  align-items: center;
  display: flex;
  height: 32px;
}

.content {
  padding: 0 20px;

  [data-autopilot-system-redesign='on'] & {
    padding: 0 40px 35px 40px;
    background-color: var(--light-100);
  }

  @include for-phone-only {
    padding: 15px;
  }
}

.footer {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  justify-content: space-between;
}

.scrollContainer {
  max-height: 400px;
  overflow-y: auto;
  padding-bottom: 30px;
  margin-bottom: -30px;
}

.guestsContainer {
  margin-top: 10px;
  display: flex;
  align-items: center;
  gap: 6px;
  padding-bottom: 20px;

  [data-autopilot-system-redesign='on'] & {
    flex-wrap: wrap;
  }

  .guestRow {
    align-items: center;
    border-radius: 20px;
    display: flex;
    gap: 5px;
    height: 32px;
    padding: 6px 12px;
    width: fit-content;
    border-radius: 16px;
    background: var(--dark-3);
  }
}

.radioOptions {
  display: flex;
  margin-top: 10px;
  gap: 12px;
  justify-content: space-between;

  > * {
    width: 50%;
  }

  .radioOptionContainer {
    @include blur(35px);
    border-radius: 10px;
    padding: 16px 20px;
    background: var(--light-60);
    border: 2px solid transparent;
    box-shadow: 1px 1px 0px 0px rgba(255, 255, 255, 0.9) inset, 0px 7px 21px 0px rgba(0, 0, 0, 0.08);

    [data-autopilot-system-redesign='on'] & {
      box-shadow: none;
      border: 1px solid var(--dark-8);
    }

    .radioOption {
      position: relative;

      > div:nth-child(2) {
        position: absolute;
        right: 0;
        top: 0;
        margin-right: 0;
      }
    }

    &.isSelected {
      border: 2px solid var(--selected-stroke);

      [data-autopilot-system-redesign='on'] & {
        border: 1px solid var(--dark-90);
      }
    }
  }

  .option {
    .icon {
      margin-bottom: 20px;
    }
  }

  @include for-phone-only {
    flex-direction: column;
    margin-bottom: 15px;

    > * {
      width: 100%;
    }
  }
}

.sendInviteFooter {
  margin-top: 20px;
}

.inheritancePopover {
  @include sm-sohne;

  background-color: var(--light-100);
  border-radius: 4px;
  box-shadow: $shadow-s2;
  height: 28px;
  min-width: unset !important;
  padding: 0;
  position: absolute;
  right: -8px;
  top: -24px;

  svg {
    fill: none !important;
  }

  button {
    height: 20px;
    min-height: 20px;
  }
}

.expandedContents {
  max-height: 0;
  overflow: hidden;
  padding-left: 24px;
  transition: max-height 0.5s ease-in-out;

  &.showing {
    max-height: 10000px;
    transition: max-height 2s ease-in-out;
  }
}

.expandedRow {
  @include md-sohne;

  align-items: center;
  border-radius: 6px;
  display: flex;
  justify-content: space-between;
  min-height: 32px;
  padding-left: 8px;

  &.withHover {
    &:hover {
      background-color: var(--dark-6);
      cursor: pointer;
    }
  }

  &.highlighted {
    background-color: var(--dark-6);
  }

  .memberCount {
    @include sm-sohne;

    color: var(--dark-30);
    padding-right: 8px;
  }

  .name {
    @include line-clamp;
    @include md-medium;

    color: var(--dark-60);
    margin: 0 4px 0 6px;
    max-width: 300px;

    &.everyoneGroup {
      max-width: 270px;
    }

    @include for-phone-only {
      max-width: 220px !important;

      &.nested {
        max-width: 200px !important;
      }
    }
  }

  .expandedRowContents {
    align-items: center;
    display: flex;
  }
}

.accesses {
  @include thinScrollbar;
  display: flex;
  flex-direction: column;
  gap: 22px;
  margin-left: -6px;
  max-height: 300px;
  overflow: auto;
  width: calc(100% + 12px);
  margin-top: 12px;

  &.withPublicAccess {
    max-height: 300px;
  }

  .header {
    @include md-medium;

    align-items: center;
    color: var(--dark-80);
    display: flex;
    flex-direction: row;
    gap: 8px;
    margin-bottom: 10px;
    padding: 0 8px;
  }

  .accessList {
    display: flex;
    flex-direction: column;

    .accessRow {
      @include md-sohne;

      border-radius: 6px;
      display: flex;
      flex-direction: row;
      justify-content: space-between;
      min-height: 32px;
      padding-left: 10px;
      position: relative;

      &.withClickAction {
        &:hover {
          cursor: pointer;
        }
      }

      &:hover {
        background-color: var(--dark-6);

        .hoverEmail {
          opacity: 1 !important;
        }

        .inviteButton {
          opacity: 1 !important;
        }

        .inheritedAccess {
          color: var(--dark-40);
        }
      }

      .inheritedAccess {
        @include md-sohne;

        color: var(--dark-30);
        padding-left: 8px;
        padding-right: 10px;
      }

      .accessRowRight {
        align-items: center;
        display: flex;

        .rightContents {
          align-items: center;
          display: flex;

          .icon {
            svg {
              fill: var(--dark-40);
            }
          }
        }
      }

      .accessRowLeft {
        align-items: center;
        color: var(--dark-80);
        display: flex;
        gap: 6px;

        .hoverEmail {
          @include line-clamp;
          @include md-sohne;

          color: var(--dark-40);
          margin-left: 6px;
          opacity: 0;
          transition: opacity 0.1s ease-in-out;
        }

        .contents {
          @include line-clamp;

          align-items: center;
          display: flex;
          width: 340px;

          @include for-phone-only {
            width: 200px;

            .name {
              max-width: 140px !important;
            }
          }

          .name {
            @include line-clamp;

            flex-shrink: 0;
            max-width: 300px;
            font-weight: 500;
          }

          .guestText {
            @include md-sohne;

            color: var(--dark-30);
            margin-left: 6px;
          }

          .icon {
            margin-left: 8px;
          }
        }
      }
    }
  }
}

.groupIcon {
  align-items: center;
  display: flex;
  height: 20px;
  justify-content: center;
  width: 20px;

  &.large {
    height: 24px;
    width: 24px;

    svg {
      height: 20px;
      width: 20px;
    }
  }

  svg {
    height: 16px;
    width: 16px;
    path {
      fill: var(--dark-40);
    }
  }
}

.inviteButton {
  opacity: 0;
  transition: opacity 0.1s ease-in-out;
}

.icon {
  height: 16px;
  width: 16px;
}

.popoverMenu {
  min-width: 160px;

  ul {
    &:focus {
      outline: none;
    }
  }
}

.backButton {
  svg {
    fill: var(--dark-40);
  }
}

.helpText {
  @include sm-sohne;

  align-items: center;
  color: var(--dark-40);
  display: flex;
  justify-content: space-between;
  margin-top: 16px;
}

.messageWrapper {
  @include input-border;
  background: var(--light-100);
  border-radius: 6px;
  flex-grow: 1;
  margin-top: 14px;
  min-height: 124px;

  div {
    min-height: 124px;
    box-shadow: none;
  }
}

.buttonContainer {
  align-items: center;
  display: flex;
  justify-content: flex-end;
  padding-right: 8px;
}

.userTab {
  @include lg-sohne;

  align-items: center;
  border: 1px solid var(--dark-10);
  border-radius: 20px;
  color: var(--dark-80);
  display: flex;
  gap: 4px;
  margin-bottom: 24px;
  padding: 4px 8px 4px 4px;
  width: fit-content;
}

.transferText {
  @include md-sohne;

  color: var(--dark-60);
  margin-bottom: 6px;
}

.footer {
  bottom: 0;
  display: flex;
  left: 0;
  position: relative;
  flex-direction: column;

  .deleteButton {
    padding: 10px;

    svg {
      fill: var(--dark-40);
    }
  }

  .passwordInputContainer {
    align-items: center;
    border-radius: 4px;
    background-color: var(--light-100);
    border: 1px solid var(--dark-10);
    display: flex;
    justify-content: space-between;
    min-height: 32px;

    padding: 3px 8px 3px 12px;

    .squareButton {
      height: 24px;
      min-height: unset;
      padding: 4px;
      width: 24px;
    }

    svg {
      height: 16px;
      width: 16px;
      fill: var(--dark-40);

      path {
        fill: var(--dark-40);
      }
    }

    input {
      @include md-sohne;
      background: transparent;
    }
  }

  .shareToWebContents {
    align-items: center;
    display: flex;
    justify-content: space-between;
    padding: 0 8px;
  }

  .shareToWeb {
    box-shadow: 0px 1px 0px 0px var(--dark-10) inset;
    padding: 16px 12px;
    position: relative;

    &.readOnly {
      align-items: center;
      display: flex;
      gap: 12px;
    }

    .publicAccessContainer {
      display: flex;
      flex-direction: column;
      gap: 2px;
      margin-top: 16px;
    }

    .passwordContainer {
      @include md-sohne;

      align-items: center;
      color: var(--dark-80);
      display: flex;
      padding: 0 8px;
      justify-content: space-between;

      .passwordLeft {
        align-items: center;
        display: flex;
      }

      .passwordRight {
        align-items: center;
        display: flex;
      }

      .lockIcon {
        align-items: center;
        display: flex;
        height: 16px;
        margin-right: 6px;
        width: 16px;

        svg {
          path {
            fill: var(--dark-40);
          }
        }
      }
    }

    .accessLevel {
      display: flex;
      justify-content: space-between;
      padding-left: 10px;

      .accessLevelLeft {
        align-items: center;
        display: flex;
        gap: 6px;

        svg {
          fill: var(--dark-40) !important;
        }
      }

      .accessText {
        @include md-sohne;

        color: var(--dark-80);
      }
    }

    .shareToWebLeft,
    .shareToWebRight {
      align-items: center;
      display: flex;
      gap: 12px;
    }

    .shareToWebText {
      .header {
        @include md-medium;
        color: var(--dark-80);
      }

      .subheader {
        @include sm-sohne;

        color: var(--dark-40);
      }
    }
  }

  .copyLinkContainer {
    align-items: center;
    box-shadow: 0px 1px 0px 0px var(--dark-10) inset;
    display: flex;
    gap: 16px;
    justify-content: space-between;
    padding: 20px;

    .linkContainer {
      @include md-sohne;
      @include line-clamp;

      border: 1px solid var(--dark-10);
      border-radius: 4px;
      color: var(--dark-40);
      padding: 8px;
      width: 100%;
    }
  }
}

@include for-phone-only {
  .footer {
    margin-top: auto;
  }
}

.secondaryActions {
  display: flex;
  align-items: center;
  margin-top: 10px;

  @include for-phone-only {
    margin-bottom: 10px;
  }

  .suggestedReviewers {
    display: flex;
    align-items: center;
    gap: 6px;
    flex-wrap: wrap;

    .suggestedReviewer {
      @include sm-sohne;
      color: var(--dark-80);
      display: flex;
      align-items: center;
      height: 24px;
      padding: 4px 8px 4px 4px;
      border-radius: 16px;
      background: var(--dark-3);
      cursor: pointer;

      &:hover {
        background-color: var(--dark-7);
      }
    }
  }
}
